<template>
   <div class="common-space-between container">
        <navBtnBlock @getVal="getVal"></navBtnBlock>
        <div class="right-div"  :style='{width:(this.$store.state.windowwidth-this.$store.state.leftBlockWidth-this.$store.state.ResetrouterNavWidth-this.$store.state.indexPadding*2)+"px",
                     height:(this.$store.state.windowHeight-130)+"px"
            }'>
            <ShowBtns/>
            <div class="common-space-between">
                <!-- <div class="common-items-center">
                    <InputBlock title="名称" ref="wordVal" placeholder="请输入名称进行搜索" maxlength="20" right="20" paddButtom="0" keyVal="" @getVal="getVal" width="200"/>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="serachBtn">搜索</el-button>
                    <el-button type="danger" icon="el-icon-refresh-right" size="small" @click="resetBtn">重置</el-button>
                    <el-button type="primary" icon="el-icon-plus" size="small" @click="addBtn">新增</el-button>
                </div>  -->
                <div class="warp-btn">
                   <el-button type="primary" icon="el-icon-download" size="small" @click="downloadBtn">导出</el-button>
                </div>
            </div>
            <div class="warp-table">
             <el-table ref="giftTable" :data="tableData" :empty-text="this.$store.state.tableEmpty" style="width: 100%"  :size="this.$store.state.tableSize" row-key="id"  :height="this.$store.state.windowHeight-270" lazy   :tree-props="{children: 'childDeparts', hasChildren: 'hasChildren'}">
               <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" type="selection"    width="60"></el-table-column>
               <el-table-column  align="center" header-align="center" :show-overflow-tooltip="true" prop="date"         label="序号"    width="100">
                  <template slot-scope="scope">{{scope.$index+1}}</template>
               </el-table-column>
               <el-table-column  prop="dictText"  label="字典数据"  width="300">
                  <template slot-scope="scope">
                      <span>{{!scope.row.dictText ? scope.row.dictNumber : scope.row.dictText}}</span>
                  </template>   
               </el-table-column>
                <el-table-column  prop="orderNo" :show-overflow-tooltip="true" align="center" header-align="center" label="排序" width="100"> </el-table-column>
                <el-table-column  prop="remarks" :show-overflow-tooltip="true" label="备注"> </el-table-column>
                <el-table-column  prop="address" :show-overflow-tooltip="true" label="状态" width="200" align="center" header-align="center">
                   <template slot-scope="scope">
                      <div class="common-space-around">
                        <span v-if="scope.row.state*1==1" class="open">启用</span>
                        <span v-else  class="disable">禁用</span>
                      </div>
                   </template>
                </el-table-column>
                <el-table-column  prop="createTime" :show-overflow-tooltip="true"  label="创建时间" width="200"> </el-table-column>
                <el-table-column  prop="address" :show-overflow-tooltip="true" label="操作" fixed="right" width="100" align="center" header-align="center">
                   <template slot-scope="scope">
                      <div class="common-space-around common-items-center operate"> 
                         <el-button  @click="ediBtn(scope.row)" type="primary" size="mini">编辑</el-button>
                     </div>
                   </template>
                </el-table-column>
             </el-table>
             <Paging @getPage="getPage" :total="total" :pageNo="current" :size="size"/>
            </div>
        </div>
        <AddBlock ref="add"></AddBlock>
        <EidtBlock ref="eidt"></EidtBlock>
   </div>
 </template>
 <script>
 import { scroll } from '../../../components/component-mixin/block-scroll'
 import navBtnBlock from './common-module/navBtn-block.vue'
 import AddBlock from './common-module/add-block.vue'
 import EidtBlock from './common-module/eidt-block.vue'
 import {url,operate} from '@/utils/config'
 import {postFun,deleteFun,getFun} from '@/utils/httpFun'
 import {setRouterNav} from '@/utils/util'
 export default {
   name: 'index',
   mixins: [scroll],
   components:{
       AddBlock:AddBlock,
       EidtBlock:EidtBlock,
       navBtnBlock:navBtnBlock
   },
   data:()=>({  
     tableData: [{}],
     dtId:0, 
     trem:{},
     current:1,
     size:10,
     total:10,   
   }),
   created(){
      setRouterNav()
      this.size = this.$store.state.pageSize
      this.getList()
   },
   methods:{
 
     //获取所有的数据
     async getList(){
         let parms = {
               param:{
                  dtId:this.dtId
               },
               current:this.current,
               size:this.size
         } 
         await postFun(operate.DICTIONARYTLIST,parms,res=>{
             this.tableData = res.data.records
             this.total = res.data.total
             this.size = res.data.size
             this.current = res.data.current
         })
     },
 
    //获取左侧单位组织
     getVal(ev){
         this.dtId = ev.id
         this.trem = ev
         this.getList()
     },
     
     //获取树形结构的信息
     async getTreeList(callback){
        let parms = {
            dtId:this.dtId
        }
        await postFun(operate.DICTIONARYTREE,parms,res=>{
            callback(!res.data ? []: res.data)
        })    
     },
     //新增单位组织弹窗父节点
     addBtn(){
        let parms = this.trem
            parms.maxNo= this.total
        this.getTreeList(res=>{
            parms.treeList=res
            this.$refs.add.showBlockMe(parms); 
        })
     },

     //编辑单位组织弹窗
     ediBtn(ev){
        let parms = this.trem
            parms.maxNo= this.total
        this.getTreeList(res=>{
            parms.treeList = res
            this.$refs.eidt.showBlockMe(parms,ev);
        })
       
     },
     
     //查找
     serachBtn(){
         this.getList()
     },

     //重置
     resetBtn(){
        this.current=1
        this.getList()
     },

     
     //导出
     downloadBtn(){
       console.log("开始导出")
     },
 
    //分页
    getPage(ev){
        this.size = ev.pageSize
        this.current = ev.pageNo 
        this.getList()
    } 
   }
 }
 </script>
 <style lang="scss" scoped>
     
     .right-div{
       position: relative;
       border: 1px solid rgba(240,240,240,0.2);
       box-shadow: -3px 3px 9px 0px rgba(205,216,233,0.2);
       padding:15px 15px 15px 15px;
       box-sizing: border-box;
       .warp-btn{
         display: flex;
         justify-content: flex-end;
       }
       .warp-table{
          padding-top:15px;
       }
       .operate{
            ::v-deep .el-button--mini{
                padding: 5px 8px;
            }
        }
    }
 </style>
 